export const splitAddress = (address: string) => {
  let parts = address.split(', ')
  parts = parts.length === 1 ? address.split('\n') : parts
  return {
    first: parts[0],
    second: parts
      .filter((_) => _.trim() !== '')
      .slice(1)
      .join(', ')
      .trim(),
  }
}
